import script from "./GoalSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoalSummary.vue?vue&type=script&setup=true&lang=ts"

import "./GoalSummary.vue?vue&type=style&index=0&id=2d9ddc22&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9ddc22"]])

export default __exports__